import { render, staticRenderFns } from "./RowResidents.vue?vue&type=template&id=eb2872a2&"
import script from "./RowResidents.vue?vue&type=script&lang=js&"
export * from "./RowResidents.vue?vue&type=script&lang=js&"
import style0 from "./RowResidents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports